export default {
  type: 'Type',
  urlBase: 'Base Website',
  habeasDataUrl: 'Habeas Data URL',
  redirectionUrl: 'Redirection URL',
  prefix: 'Prefix',
  appExtradata: 'People custom fields',
  appExtradataBusiness: 'Companies custom fields',
  addExtradataField: 'Add field',
  appExtradataAddSuccess: 'Custom field added successfully',
  appExtradataEditSuccess: 'Custom field edit successfully',
  appExtradataDelete: 'Successfully removed',
  appExtradataDeleteAll: 'Successfully removed',
  appExtradataAddError: 'An error occurred',
  additionalFieldAlreadyExists: 'The custom field already exists',
  taskTypes: 'Task types',
  tasktype: 'Task type',
  addTaskType: 'Add task type',
  credentials: 'Credentials',
  microsite: 'Microsite',
  micrositeTitle: 'Title',
  micrositeBio: 'Bio',
  micrositeName: 'Name',
  micrositeInstagramLink: 'Instagram link',
  micrositeFacebookLink: 'Facebook link',
  micrositeEmail: 'Email',
  micrositeWhatsappLink: 'Whatsapp link',
  apiKeys: 'API keys',
  appId: 'App ID',
  companyId: 'Company ID',
  keybeUI: 'Keybe UI',
  publicKey: 'Public key',
  privateKey: 'Private key',
  testEnvironment: 'Test environment',
  //  custom extradata
  extraCreatorShortText: 'Short text field',
  extraCreatorLongText: 'Long text field',
  extraCreatorList: 'Dropdown list',
  extraCreatorRadioList: 'Radio buttons list',
  extraCreatorCheckList: 'Checkboxes list',
  extraCreatorEmail: 'Email',
  numeric: 'Numeric',
  money: 'Currency',
  datetime: 'Date and time',
  extraCreatorApplicationInfo: 'Allow users to view and modify this field from their profile',
  extraCreatorApplication: 'Application',
  extraCreatorPersonInfo: 'Allow users to view and modify this field from their profile',
  person: 'Person',
  fieldName: 'Field name',
  fieldType: 'Field type',
  fieldAccess: 'Field access',
  addSomeTags: 'Add some tags',
  option: 'Option',
  order: 'Order',
  addOptions: 'Add options',
  showFieldInPersonFilter: 'Show field in people filter',
  showFieldInBusinessFilter: 'Show field in companies filter',
  editField: 'Edit field',
  noTagsAddOne: 'No tags, add one by pressing enter',
  removeExtradata: 'Remove field',
  removeExtradataDescription: 'Do you want to remove this data from all people? Or just hide it?',
  removeExtraDataDescriptionBusiness: 'Do you want to remove this custom field from all companies? Or just hide it?',
  justRemove: 'Hide',
  removeForAll: 'Remove from all people',
  removeForAllBusiness: 'Remove from all companies',
  removeTaskType: 'Remove task type',
  removeTaskTypeDescription: 'Do you want to remove this task type?',
  copiedToClipboard: 'Copied to clipboard',
  errorCopyingToClipboard: 'Error copying to clipboard',
  refreshPublicKey: 'Refresh public key',
  refreshPublicKeyDescription: 'Changing the public key affects all applications where it is in use. Do you want to continue?',
  allFieldsRequired: 'All fields are required',
  updateDataSuccess: 'Data updated successfully',
  updateDataError: 'Error updating data',
  dateFrom: 'From',
  dateTo: 'To',
  untilTo: 'Until',
  calculate: 'Calculate',
  DomainEmails: 'Enter your email',
  Domain: 'Domain configuration',
  per_page: 'Items per page',
  DomainName: 'Domain name',
  verifieddomain: 'Verified domain',
  dkinsettings: 'DKIM settings',
  spfsettings: 'SPF settings',
  createNewDomain: 'Create new domain',
  domainSuccessfullyCreated: 'Domain created successfully',
  formNameDomain: 'Domain name',
  Domaincheck: 'Verify domain',
  DomaincheckTitle: 'Verify',
  domainSuccessfullyVerefied: 'Domain verified',
  domainSuccessfullyVerefiedEmail: 'Verification email sent',
  configText1: 'We need to verify that you have access to an email account or to the TXT records in your domain',
  configText2: 'Create a TXT record in your domain\'s DNS with the following value:',
  configText3: 'Alternatively, enter an email address and we will send you a verification link.',
  domainConfigSPF: 'To enable SPF, add another TXT record, this time for the bare domain you added as your sending domain',
  domainConfigDKIM1: 'Add a new TXT record with the name ',
  domainConfigDKIM2: 'the value for the record should be',
  domainConfigInfoDKIMSPF: 'Once you’ve added your sending domain, you’ll need to create DNS records that enable DKIM and SPF email authentication for that domain. ',
  goToApiDocs: 'Go to API docs',
  errorGettingAppConfig: 'Error getting app config',
  dialogAllFieldsAreRequired: 'All fields are required',
  dialogYouMustAddAtLeastOneOption: 'You must add at least one option',
  dialogThereCanBeNoBlankOptions: 'There can be no blank options',
  errorCreatingExtradata: 'Error creating custom field',
  errorUpdatingExtradata: 'Error updating custom field',
  errorAddingTaskType: 'Error adding task type',
  enterATaskName: 'You must add a task name',
  generateInstagramAccessToken: 'Generate Instagram access token',
  generateToken: 'Generate token',
  accessToken: 'Access token',
  removeExtraData: 'Remove field',
  removeExtraDataDescription: 'Do you want to delete this field from all people? Or would you rather just hide it?'
}
